<template>
  <b-modal
    :title=modalTitle
    ref="compare-modal3"
    id="compare-modal3"
    size="lg"
    hide-footer
    @hidden="resetModal"
    no-close-on-backdrop
    centered
  >
    <!-- <b-card class="m-0" style="font-family: NanumBarunGothic;"> -->
    <section style="font-family: NanumBarunGothic;">
      <b-row>
        <!-- 구분 영역 -->        
        <b-col style="max-width: 12%">
          <b-row>
            <b-col>
              <b-form-radio-group
                id="radio-group-c"
                v-model="compareSelectedRadio"
                :options="compareRadioOptions"
                name="radio-options-c"
                style="margin-top: 1rem;"
              ></b-form-radio-group>
            </b-col>
          </b-row>
          <b-row class="compareSideMenu">
            <b-col>
              <div>
                <b-row>
                  <b-col>
                    <h3 style="text-align: center;">구분</h3>
                  </b-col>
                </b-row>
                <b-row class="compareSideMenuInner">
                  <b-col style="position: relative;">
                    <div id="compareLoadingGubun" class="text-center text-primary my-2" style="position: absolute; top: 350%; left: 40%; visibility: visible;">
                      <b-spinner class="align-middle mr-2"></b-spinner>
                      <strong>분석중...</strong>
                    </div>
                    <div>
                      <b-form-group>
                        <template #label>
                          <b-form-checkbox
                            id="gubunCompare"
                            v-model="compareAllSelected"
                            :indeterminate="compareIndeterminate"
                            aria-describedby="compareGubuns"
                            aria-controls="compareGubuns"
                            @change="toggleAll"
                          >
                            {{ compareAllSelected ? '전체 선택 해제' : '전체 선택' }}
                          </b-form-checkbox>
                        </template>
                        <ul id="checkboxC">
                          <li v-for="object in compareGubunsObjects" :key="object.value" style="list-style-type: none; margin-top: 1rem;">
                            <b-form-checkbox
                              v-model="compareSelectedGubuns"
                              label="체크박스"
                              :id="object.type"
                              :value="object.value"
                              >
                              {{ object.value }}
                            </b-form-checkbox>
                          </li>
                        </ul>
                      </b-form-group>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-button id="filter_btn" style="height: auto; width: 100%; padding: 0.6rem 0.85rem; margin-right: 5px; margin-top: 1rem;" @click="loadChartData1">
                      <div>
                        적용하기
                      </div>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <!-- 1번째 태그순위 영역 -->
        <b-col style="max-width: 18%; padding-left: 2rem;"> 
          <b-row style="margin-top: 5rem;">
            <b-col style="text-align: center; font-size: 2rem;">
              <h3>TAG 순위</h3>
            </b-col>
          </b-row>
          <b-row>
            <b-col style="padding-left: 0.25rem; ">
              <b-table
                class="tableR position-relative"
                ref="refSearchTagTableR"
                id="searchTagTableR"
                :items="fetchGroupsR"
                :fields="tableColumnsR"
                :busy="isBusyR"
                :sort-desc.sync="sortDescR" 
                :sort-by.sync="sortByR"
                :sort-direction='sortDirectionR'
                responsive
                show-empty
                no-border-collapse
                outlined
                head-variant="light"
                table-class="table-font-size"
                empty-text="해당하는 TAG가 없습니다."
                sticky-header="true"
                style="max-height: 550px;"
              >
                <template #head()="{ label, field: { key, sortable } }">
                  {{ label }}
                  <template v-if="sortable">
                    <b-img v-if="sortByR !== key" src="/caretupdown.png" style="width: 10px; margin-top: -2px;"></b-img>
                    <b-img v-else-if="sortDescR" src="/caretup.png" style="width: 9px;"></b-img>
                    <b-img v-else src="/caretdown.png" style="width: 9px;"></b-img>
                  </template>
                </template>
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle mr-2"></b-spinner>
                    <strong>분석중...</strong>
                  </div>
                </template>

                <template #cell(rank)="data">
                    <div>{{ data.item.rank }}</div>
                </template>
                <template #cell(tag)="data">
                  <div style="display: flex; align-items: center;">
                    <div v-if="data.item.color == '#FF9F4A'" style="display: inline-block; width: 1rem; height: 1rem; background: #FF9F4A;"></div> 
                    <div v-else-if="data.item.color == '#FF7070'" style="display: inline-block; width: 1rem; height: 1rem; background: #FF7070;"></div> 
                    <div v-else-if="data.item.color == '#FDA8AA'" style="display: inline-block; width: 1rem; height: 1rem; background: #FDA8AA;"></div> 
                    <div v-else-if="data.item.color == '#86C98A'" style="display: inline-block; width: 1rem; height: 1rem; background: #86C98A;"></div> 
                    <div v-else-if="data.item.color == '#887CAF'" style="display: inline-block; width: 1rem; height: 1rem; background: #887CAF;"></div> 
                    <div v-else-if="data.item.color == '#E3A209'" style="display: inline-block; width: 1rem; height: 1rem; background: #E3A209;"></div> 
                    <div v-else-if="data.item.color == '#CB87AF'" style="display: inline-block; width: 1rem; height: 1rem; background: #CB87AF;"></div> 
                    <div v-else-if="data.item.color == '#09D8E3'" style="display: inline-block; width: 1rem; height: 1rem; background: #09D8E3;"></div> 
                    <div v-else-if="data.item.color == '#FFD1AA'" style="display: inline-block; width: 1rem; height: 1rem; background: #FFD1AA;"></div> 
                    <div v-else-if="data.item.color == '#748BA7'" style="display: inline-block; width: 1rem; height: 1rem; background: #748BA7;"></div> 
                    <div v-else-if="data.item.color == '#9675AB'" style="display: inline-block; width: 1rem; height: 1rem; background: #9675AB;"></div> 
                    <div v-else-if="data.item.color == '#0993E3'" style="display: inline-block; width: 1rem; height: 1rem; background: #0993E3;"></div> 
                    <div v-else-if="data.item.color == '#D46A6A'" style="display: inline-block; width: 1rem; height: 1rem; background: #D46A6A;"></div> 
                    <div v-else-if="data.item.color == '#55AA55'" style="display: inline-block; width: 1rem; height: 1rem; background: #55AA55;"></div> 
                    <div v-else-if="data.item.color == '#615192'" style="display: inline-block; width: 1rem; height: 1rem; background: #615192;"></div> 
                    <div v-else-if="data.item.color == '#D4C16A'" style="display: inline-block; width: 1rem; height: 1rem; background: #D4C16A;"></div> 
                    <div v-else-if="data.item.color == '#18516f'" style="display: inline-block; width: 1rem; height: 1rem; background: #18516f;"></div> 
                    <div v-else-if="data.item.color == '#4F608F'" style="display: inline-block; width: 1rem; height: 1rem; background: #4F608F;"></div> 
                    <div v-else-if="data.item.color == '#D4A16A'" style="display: inline-block; width: 1rem; height: 1rem; background: #D4A16A;"></div> 
                    <div v-else-if="data.item.color == '#AA3939'" style="display: inline-block; width: 1rem; height: 1rem; background: #AA3939;"></div> 
                    <div v-else-if="data.item.color == '#2D882D'" style="display: inline-block; width: 1rem; height: 1rem; background: #2D882D;"></div> 
                    <div v-else-if="data.item.color == '#403075'" style="display: inline-block; width: 1rem; height: 1rem; background: #403075;"></div> 
                    <div v-else-if="data.item.color == '#AA9439'" style="display: inline-block; width: 1rem; height: 1rem; background: #AA9439;"></div> 
                    <div v-else-if="data.item.color == '#2E4172'" style="display: inline-block; width: 1rem; height: 1rem; background: #2E4172;"></div> 
                    <div v-else-if="data.item.color == '#AA7239'" style="display: inline-block; width: 1rem; height: 1rem; background: #AA7239;"></div> 
                    <div v-else-if="data.item.color == '#801515'" style="display: inline-block; width: 1rem; height: 1rem; background: #801515;"></div> 
                    <div v-else-if="data.item.color == '#196811'" style="display: inline-block; width: 1rem; height: 1rem; background: #196811;"></div> 
                    <div v-else-if="data.item.color == '#261758'" style="display: inline-block; width: 1rem; height: 1rem; background: #261758;"></div> 
                    <div v-else-if="data.item.color == '#806C15'" style="display: inline-block; width: 1rem; height: 1rem; background: #806C15;"></div> 
                    <div v-else-if="data.item.color == '#162955'" style="display: inline-block; width: 1rem; height: 1rem; background: #162955;"></div> 
                    <div v-else-if="data.item.color == '#804815'" style="display: inline-block; width: 1rem; height: 1rem; background: #804815;"></div> 
                    <div v-else-if="data.item.color == '#550200'" style="display: inline-block; width: 1rem; height: 1rem; background: #550200;"></div> 
                    <div v-else-if="data.item.color == '#034500'" style="display: inline-block; width: 1rem; height: 1rem; background: #034500;"></div> 
                    <div v-else-if="data.item.color == '#13073A'" style="display: inline-block; width: 1rem; height: 1rem; background: #13073A;"></div> 
                    <div v-else-if="data.item.color == '#554600'" style="display: inline-block; width: 1rem; height: 1rem; background: #554600;"></div> 
                    <div v-else-if="data.item.color == '#061539'" style="display: inline-block; width: 1rem; height: 1rem; background: #061539;"></div> 
                    <div v-else-if="data.item.color == '#552700'" style="display: inline-block; width: 1rem; height: 1rem; background: #552700;"></div> 
                    <div v-else-if="data.item.color == '#AA5585'" style="display: inline-block; width: 1rem; height: 1rem; background: #AA5585;"></div> 
                    <div v-else-if="data.item.color == '#B4CB65'" style="display: inline-block; width: 1rem; height: 1rem; background: #B4CB65;"></div> 
                    <div v-else-if="data.item.color == '#724C8F'" style="display: inline-block; width: 1rem; height: 1rem; background: #724C8F;"></div> 
                    <div v-else-if="data.item.color == '#467386'" style="display: inline-block; width: 1rem; height: 1rem; background: #467386;"></div> 
                    <div v-else style="display: inline-block; width: 1rem; height: 1rem; background: red;">{{ data.item.color }} </div> 
                    <div style="display: inline-block; margin-left: 0.3rem;">{{ data.item.tag }}</div>
                    <div v-if="data.item.sgroup == 3" style="display: inline-block; margin-left: 0.3rem; color: #146EBE;"><i class="fa-solid fa-clone"></i></div>
                  </div>
                </template>
                <template #cell(frequency)="data">
                    <div>{{ data.item.frequency.toLocaleString() }}</div>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-col>
        <!-- 차트 영역 -->
        <b-col> 
          <b-row>
            <b-col>
            <vue-select
              class="select-brand"
              label="title"            
              :options="compareBrandList"
              :clearable="true"
              v-model="compareSelectedBrand1"
              placeholder="브랜드(전체)"
              style="height: 32px; width: 180px; text-align: center; font-size: 12px; font-weight: 600; margin-left: 5px;"
            >
            </vue-select>
            </b-col>
            <b-col>
              <vue-select
                class="select-brand"
                label="title"            
                :options="compareBrandList"
                :clearable="true"
                v-model="compareSelectedBrand2"
                placeholder="브랜드(전체)"
                style="height: 32px; width: 180px; text-align: center; font-size: 12px; font-weight: 600; margin-left: 5px;"
              >
              </vue-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col id="compareChartCol1" style="position: relative; min-height: 730px;">
              <div id="compareLoadingNet1" class="text-center text-primary my-2" style="position: absolute; top: 40%; left: 45%; visibility: visible;">
                <b-spinner class="align-middle mr-2"></b-spinner>
                <strong>분석중...</strong>
              </div>
              <div id="compareNet1" ref="compareNet1" style="position: absolute; margin-left: 0rem;">
                <div class="graphic-container" style="margin-top: 0.5rem;">
                  <compare-chart-net4 
                  :netChartNodes="compareNodesSubBrand1"
                  :netChartLinks="compareLinksSubBrand1"
                  :dupNodeId="dupNodeId"
                  />
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <!-- 2번째 태그순위 영역 -->
        <b-col style="max-width: 18%; visibility: hidden;" id="tagCol2"> 
          <b-row style="margin-top: 5rem;">
            <b-col style="text-align: center; font-size: 2rem;">
              <h3>TAG 순위</h3>
            </b-col>
          </b-row>
          <b-row>
            <b-col style="padding-left: 0.25rem; ">
              <b-table
                class="tableL position-relative"
                ref="refSearchTagTableL"
                id="searchTagTableL"
                :items="fetchGroupsL"
                :fields="tableColumnsL"
                :busy="isBusyL"
                :sort-desc.sync="sortDescL" 
                :sort-by.sync="sortByL"
                :sort-direction='sortDirectionL'
                responsive
                show-empty
                no-border-collapse
                outlined
                head-variant="light"
                table-class="table-font-size"
                empty-text="해당하는 TAG가 없습니다."
                sticky-header="true"
                style="max-height: 550px;"
              >
                <template #head()="{ label, field: { key, sortable } }">
                  {{ label }}
                  <template v-if="sortable">
                    <b-img v-if="sortByL !== key" src="/caretupdown.png" style="width: 10px; margin-top: -2px;"></b-img>
                    <b-img v-else-if="sortDescL" src="/caretup.png" style="width: 9px;"></b-img>
                    <b-img v-else src="/caretdown.png" style="width: 9px;"></b-img>
                  </template>
                </template>
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle mr-2"></b-spinner>
                    <strong>분석중...</strong>
                  </div>
                </template>

                <template #cell(rank)="data">
                    <div>{{ data.item.rank }}</div>
                </template>
                <template #cell(tag)="data">
                  <div style="display: flex; align-items: center;">
                    <div v-if="data.item.color == '#FF9F4A'" style="display: inline-block; width: 1rem; height: 1rem; background: #FF9F4A;"></div> 
                    <div v-else-if="data.item.color == '#FF7070'" style="display: inline-block; width: 1rem; height: 1rem; background: #FF7070;"></div> 
                    <div v-else-if="data.item.color == '#FDA8AA'" style="display: inline-block; width: 1rem; height: 1rem; background: #FDA8AA;"></div> 
                    <div v-else-if="data.item.color == '#86C98A'" style="display: inline-block; width: 1rem; height: 1rem; background: #86C98A;"></div> 
                    <div v-else-if="data.item.color == '#887CAF'" style="display: inline-block; width: 1rem; height: 1rem; background: #887CAF;"></div> 
                    <div v-else-if="data.item.color == '#E3A209'" style="display: inline-block; width: 1rem; height: 1rem; background: #E3A209;"></div> 
                    <div v-else-if="data.item.color == '#CB87AF'" style="display: inline-block; width: 1rem; height: 1rem; background: #CB87AF;"></div> 
                    <div v-else-if="data.item.color == '#09D8E3'" style="display: inline-block; width: 1rem; height: 1rem; background: #09D8E3;"></div> 
                    <div v-else-if="data.item.color == '#FFD1AA'" style="display: inline-block; width: 1rem; height: 1rem; background: #FFD1AA;"></div> 
                    <div v-else-if="data.item.color == '#748BA7'" style="display: inline-block; width: 1rem; height: 1rem; background: #748BA7;"></div> 
                    <div v-else-if="data.item.color == '#9675AB'" style="display: inline-block; width: 1rem; height: 1rem; background: #9675AB;"></div> 
                    <div v-else-if="data.item.color == '#0993E3'" style="display: inline-block; width: 1rem; height: 1rem; background: #0993E3;"></div> 
                    <div v-else-if="data.item.color == '#D46A6A'" style="display: inline-block; width: 1rem; height: 1rem; background: #D46A6A;"></div> 
                    <div v-else-if="data.item.color == '#55AA55'" style="display: inline-block; width: 1rem; height: 1rem; background: #55AA55;"></div> 
                    <div v-else-if="data.item.color == '#615192'" style="display: inline-block; width: 1rem; height: 1rem; background: #615192;"></div> 
                    <div v-else-if="data.item.color == '#D4C16A'" style="display: inline-block; width: 1rem; height: 1rem; background: #D4C16A;"></div> 
                    <div v-else-if="data.item.color == '#18516f'" style="display: inline-block; width: 1rem; height: 1rem; background: #18516f;"></div> 
                    <div v-else-if="data.item.color == '#4F608F'" style="display: inline-block; width: 1rem; height: 1rem; background: #4F608F;"></div> 
                    <div v-else-if="data.item.color == '#D4A16A'" style="display: inline-block; width: 1rem; height: 1rem; background: #D4A16A;"></div> 
                    <div v-else-if="data.item.color == '#AA3939'" style="display: inline-block; width: 1rem; height: 1rem; background: #AA3939;"></div> 
                    <div v-else-if="data.item.color == '#2D882D'" style="display: inline-block; width: 1rem; height: 1rem; background: #2D882D;"></div> 
                    <div v-else-if="data.item.color == '#403075'" style="display: inline-block; width: 1rem; height: 1rem; background: #403075;"></div> 
                    <div v-else-if="data.item.color == '#AA9439'" style="display: inline-block; width: 1rem; height: 1rem; background: #AA9439;"></div> 
                    <div v-else-if="data.item.color == '#2E4172'" style="display: inline-block; width: 1rem; height: 1rem; background: #2E4172;"></div> 
                    <div v-else-if="data.item.color == '#AA7239'" style="display: inline-block; width: 1rem; height: 1rem; background: #AA7239;"></div> 
                    <div v-else-if="data.item.color == '#801515'" style="display: inline-block; width: 1rem; height: 1rem; background: #801515;"></div> 
                    <div v-else-if="data.item.color == '#196811'" style="display: inline-block; width: 1rem; height: 1rem; background: #196811;"></div> 
                    <div v-else-if="data.item.color == '#261758'" style="display: inline-block; width: 1rem; height: 1rem; background: #261758;"></div> 
                    <div v-else-if="data.item.color == '#806C15'" style="display: inline-block; width: 1rem; height: 1rem; background: #806C15;"></div> 
                    <div v-else-if="data.item.color == '#162955'" style="display: inline-block; width: 1rem; height: 1rem; background: #162955;"></div> 
                    <div v-else-if="data.item.color == '#804815'" style="display: inline-block; width: 1rem; height: 1rem; background: #804815;"></div> 
                    <div v-else-if="data.item.color == '#550200'" style="display: inline-block; width: 1rem; height: 1rem; background: #550200;"></div> 
                    <div v-else-if="data.item.color == '#034500'" style="display: inline-block; width: 1rem; height: 1rem; background: #034500;"></div> 
                    <div v-else-if="data.item.color == '#13073A'" style="display: inline-block; width: 1rem; height: 1rem; background: #13073A;"></div> 
                    <div v-else-if="data.item.color == '#554600'" style="display: inline-block; width: 1rem; height: 1rem; background: #554600;"></div> 
                    <div v-else-if="data.item.color == '#061539'" style="display: inline-block; width: 1rem; height: 1rem; background: #061539;"></div> 
                    <div v-else-if="data.item.color == '#552700'" style="display: inline-block; width: 1rem; height: 1rem; background: #552700;"></div> 
                    <div v-else-if="data.item.color == '#AA5585'" style="display: inline-block; width: 1rem; height: 1rem; background: #AA5585;"></div> 
                    <div v-else-if="data.item.color == '#B4CB65'" style="display: inline-block; width: 1rem; height: 1rem; background: #B4CB65;"></div> 
                    <div v-else-if="data.item.color == '#724C8F'" style="display: inline-block; width: 1rem; height: 1rem; background: #724C8F;"></div> 
                    <div v-else-if="data.item.color == '#467386'" style="display: inline-block; width: 1rem; height: 1rem; background: #467386;"></div> 
                    <div v-else style="display: inline-block; width: 1rem; height: 1rem; background: red;">{{ data.item.color }} </div> 
                    <div style="display: inline-block; margin-left: 0.3rem;">{{ data.item.tag }}</div>
                    <div v-if="data.item.sgroup == 3" style="display: inline-block; margin-left: 0.3rem; color: #146EBE;"><i class="fa-solid fa-clone"></i></div>
                  </div>
                </template>
                <template #cell(frequency)="data">
                    <div>{{ data.item.frequency.toLocaleString() }}</div>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>


    </section>
  </b-modal>
</template>

<script>
import { 
    BCard, 
    BCol, 
    BRow, 
    BCardBody, 
    BButton,
    BCardText,
    BFormRadio, 
    BFormRadioGroup,
    BTable, 
    BPagination,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BTooltip,
    BFormCheckbox,
    BFormCheckboxGroup,
    BImg,
} from "bootstrap-vue";

import CompareChartNet1 from "@/views/cis-searchtag/components/CompareChartNet1.vue";
import CompareChartNet2 from "@/views/cis-searchtag/components/CompareChartNet2.vue";
import CompareChartNet3 from "@/views/cis-searchtag/components/CompareChartNet3.vue";
import CompareChartNet4 from "@/views/cis-searchtag/components/CompareChartNet4.vue";

import CisSearchTagService from "@/services/cis-searchtag.service";

import axios from "axios"

const stringStyle = { font: { name: 'Consolas' } };
const indexNumStyle = { font: { name: 'Consolas' }, numFmt: "0" };
const intNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0" };
const intNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0;[Red]\\ \\▼#,##0;[Black]\\ \"-\"" };
const floatNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0" };
const rateNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0%" };
const rateNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0%;[Red]\\ \\▼#,##0%;[Black]\\ \"-\"" };

const boldStyle = { font: { name: 'Consolas', bold: true } };
const underlineStyle = { font: { name: 'Consolas', underline: true} };

const sleep = delay => new Promise(resolve => setTimeout(resolve, delay));

const cancelToken = axios.CancelToken;
var source = cancelToken.source();


export default {
  name: "CompareModal",
  components: {
    BCard, 
    BCol, 
    BRow, 
    BCardBody, 
    BButton,
    BCardText,
    BFormRadio, 
    BFormRadioGroup,
    BTable, 
    BPagination,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BTooltip,
    BFormCheckbox,
    BFormCheckboxGroup,
    BImg,
    

    CompareChartNet1,
    CompareChartNet2,
    CompareChartNet3,
    CompareChartNet4,

    

  },
  props: {
    compareFirstClass: {
      type: Object,
      default: null,
    },
    compareMiddleClass: {
      type: String,
      default: '',
    },
    compareDates: {
      type: Array,
      default: () => [],
    },
    compareBrand: {
      type: String,
      default: '',
    },
    compareShow2: {
      type: Boolean,
      default: false,
    },
    compareBrandList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      modalTitle: 'SEARCH TAG 경쟁분석',
      compareSelectedBrand1: null,
      compareSelectedBrand2: null,

      compareNodesSubBrand1: [], 
      compareLinksSubBrand1: [],

      compareNodesSubBrand2: [], 
      compareLinksSubBrand2: [],

      dupNodeId: [],


      compareGubunsObjects: [
        { type: "subBrand", value: "라인 브랜드"},
        { type: "productName", value: "상품명"}
      ],
      compareGubuns:['라인 브랜드', '상품명'],

      compareSelectedGubuns: ["라인 브랜드", "상품명"],
      compareAllSelected: true,
      compareIndeterminate: false,

      compareRadioOptions: [
        { text : '속성', value: 'attributes'},
        { text : '라인 브랜드/상품명', value: 'brands'}
      ],
      compareSelectedRadio: 'attributes',

      nodeColors : [
        '#FDA8AA', '#86C98A', '#887CAF', '#E3A209', '#CB87AF', '#09D8E3', '#FFD1AA', '#748BA7', '#9675AB', '#0993E3', '#D46A6A', '#55AA55', '#615192', '#D4C16A', '#18516f', '#4F608F', '#D4A16A', '#AA3939', 
        '#2D882D', '#403075', '#AA9439', '#2E4172', '#AA7239', '#801515', '#196811', '#261758', '#806C15', '#162955', '#804815', '#550200', '#034500', '#13073A', '#554600', '#061539', '#552700', '#AA5585', 
        '#B4CB65', '#18516f', '#724C8F', '#467386'
      ],

      tableColumnsR: [
        { key: 'rank', label: '순위',  sortable: true, thClass: 'text-left w20', tdClass: 'text-center'},
        { key: 'tag', label: 'TAG', sortable: true , thClass: 'text-left'},
        { key: 'frequency', label: '검색량', sortable: true , thClass: 'text-right', tdClass: 'text-right'},
      ],
      fetchGroupsR: null,
      isBusyR: false,
      sortByR: null,
      sortDescR: false,
      sortDirectionR: 'desc',

      tableColumnsL: [
        { key: 'rank', label: '순위',  sortable: true, thClass: 'text-left w20', tdClass: 'text-center'},
        { key: 'tag', label: 'TAG', sortable: true , thClass: 'text-left'},
        { key: 'frequency', label: '검색량', sortable: true , thClass: 'text-right', tdClass: 'text-right'},
      ],
      fetchGroupsL: null,
      isBusyL: false,
      sortByL: null,
      sortDescL: false,
      sortDirectionL: 'desc',

      
    };
  },
  watch: {
    compareShow2(){
      console.log('-- watch compareShow2 --')      
      console.log(this.compareShow2)
      this.compareSelectedBrand1 = this.compareBrand
      // compareShow1 이 true 일 때 데이터 로드 해야함
      if(this.compareShow2){
        this.setGubuns()
      }
    },
    compareSelectedRadio(){
      console.log(this.compareSelectedRadio)
      this.setGubuns();
    },
    compareSelectedBrand1(){
      this.loadChartData1()
    },
    compareSelectedBrand2(){
      this.loadChartData1()
    },
  },
  methods: {
    resetModal(){
      console.log('-- resetModal --')
      // 부모가 compareShow1을 false로 바꿔야함
      this.$parent.changeCompareShow2()
      this.compareSelectedBrand2 = '';
    },

    toggleAll(checked) {
        this.compareSelectedGubuns = checked ? this.compareGubuns.slice() : []
    },

    async setGubuns(){
      console.log("setGubuns")
      this.compareGubunsObjects = []
      this.compareGubuns = []
      this.compareSelectedGubuns = []

      this.isBusyR = true;
      this.fetchGroupsR = [];
      this.isBusyL = true;
      this.fetchGroupsL = [];

      
      var fcls_sq = null
      if(this.compareFirstClass != null)
        fcls_sq = this.compareFirstClass.id
      
      var brand = null
      // if(this.selectedBrand1 != null)
      //   brand = this.selectedBrand1

      var sel_Middle = this.compareMiddleClass != null ? this.compareMiddleClass : null; 
      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'

      console.log('fcls_sq : ', fcls_sq)
      console.log('brand : ', brand)
      console.log('sel_Middle : ', sel_Middle)

      const response = await CisSearchTagService.listGubunC({
        startDate : this.compareDates[0],
        endDate : this.compareDates[1],
        ctgSq : this.$store.getters.getSelectedCategory,
        fclsSq : fcls_sq,
        brand : brand,
        middle : sel_Middle,
        type : this.compareSelectedRadio
      }, source)

      if (response && response.status === 200) {
        console.log('-- gubun data --')
        console.log(response)

        this.compareGubunsObjects = response.data.data

        for(const item of response.data.data) {
          this.compareGubuns.push(item.value)
          this.compareSelectedGubuns.push(item.value)
        }

        if(document.getElementById('compareLoadingGubun')){
          document.getElementById('compareLoadingGubun').style.visibility = "hidden";
        }

        this.loadChartData1()
      }


    },


    async loadChartData1(){
      console.log('-- loadChartData1 --')
      //차트 초기화
      if(document.getElementById('compareNet1')){
        document.getElementById('compareNet1').style.visibility = "hidden";
      }
      if(document.getElementById('compareLoadingNet1')){
        document.getElementById('compareLoadingNet1').style.visibility = "visible";
      }
      this.isBusyR = true;
      this.fetchGroupsR = [];
      this.isBusyL = true;
      this.fetchGroupsL = [];

      var fcls_sq = null
      if(this.compareFirstClass != null)
        fcls_sq = this.compareFirstClass.id
      
      var sel_Middle = this.compareMiddleClass != null ? this.compareMiddleClass : null; 
      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'


      var brand1 = null
      if(this.compareSelectedBrand1 != null)
        brand1 = this.compareSelectedBrand1
      if(brand1 == '')
        brand1 = null

      var brand2 = null
      if(this.compareSelectedBrand2 != null)
        brand2 = this.compareSelectedBrand2
      if(brand2 == '')
        brand2 = null

      console.log('fcls_sq : ', fcls_sq)
      console.log('sel_Middle : ', sel_Middle)
      console.log('brand1 : ', brand1)
      console.log('brand2 : ', brand2)

      // 브랜드가 같을때
      if(brand1 == brand2){
        const response = await CisSearchTagService.getBrandPinData({
          startDate : this.compareDates[0],
          endDate : this.compareDates[1],
          ctgSq : this.$store.getters.getSelectedCategory,
          fclsSq : fcls_sq,
          brand : brand1,
          middle : sel_Middle,
          type : this.compareSelectedRadio,
          gubuns : this.compareSelectedGubuns
        }, source);

        if (response && response.status === 200) {        
          console.log(response)

          var tag_rank = 0
          
          this.isBusyR = false;

          // net chart update
          console.log('-- net chart update --')
          var group1_id = ''
          if(brand1 == null)
            group1_id = '전체'
          else
            group1_id = brand1
          //////////////////////////////////////////////////////////////////////////
          var node_cnt = 0

          this.compareNodesSubBrand1 = []
          this.compareLinksSubBrand1 = []
          this.compareNodesSubBrand1.push({ id: group1_id, group: 2, freq: 0 })
          
          this.subBrandList = []
          this.productList = []
          this.cdjContentList = []
          this.selectedNode = null

          for(const item of response.data.data) {
            var node_color = ''
            node_cnt += 1
            if(node_cnt <= 30){
              if(item.subTitle == '라인 브랜드'){
                this.subBrandList.push(item.sub)
                node_color = '#FF9F4A'
              }else if(item.subTitle == '상품명'){
                this.productList.push(item.sub)
                node_color = '#FF7070'
              }else{
                this.cdjContentList.push(item.sub)
                var gubun_idx = this.compareGubuns.indexOf(item.subTitle)
                node_color = this.nodeColors[gubun_idx]
              }
              this.compareNodesSubBrand1.push({id: item.sub, group: 3, freq: item.freq, gubun: item.subTitle, rank: node_cnt, color: node_color})
              this.compareLinksSubBrand1.push({ source: group1_id, target: item.sub })
              //right table update
              tag_rank += 1
              this.fetchGroupsR.push({
                rank: tag_rank,
                tag: item.sub,
                frequency: Math.round(item.freq),
                color: node_color,
                sgroup: 1
              })
            }
          }
          if(document.getElementById('compareNet1')){
            document.getElementById('compareNet1').style.visibility = "visible";
          }
          if(document.getElementById('compareLoadingNet1')){
            document.getElementById('compareLoadingNet1').style.visibility = "hidden";
          }
          if(document.getElementById('tagCol2')){
            document.getElementById('tagCol2').style.visibility = "hidden";
          }

        }

      }else{ // 브랜드가 다를때
        const response = await CisSearchTagService.getBrandPinData({
          startDate : this.compareDates[0],
          endDate : this.compareDates[1],
          ctgSq : this.$store.getters.getSelectedCategory,
          fclsSq : fcls_sq,
          brand : brand1,
          middle : sel_Middle,
          type : this.compareSelectedRadio,
          gubuns : this.compareSelectedGubuns
        }, source);

        const response2 = await CisSearchTagService.getBrandPinData({
          startDate : this.compareDates[0],
          endDate : this.compareDates[1],
          ctgSq : this.$store.getters.getSelectedCategory,
          fclsSq : fcls_sq,
          brand : brand2,
          middle : sel_Middle,
          type : this.compareSelectedRadio,
          gubuns : this.compareSelectedGubuns
        }, source);

        if (response && response.status === 200 && response2 && response2.status === 200) {        
          console.log(response)
          console.log(response2)
          // net chart update
          console.log('-- net chart update --')

          var tag_rankR = 0
          this.isBusyR = false;
          var tag_rankL = 0
          this.isBusyL = false;
          
          var group1_id = ''
          if(brand1 == null)
            group1_id = '전체'
          else
            group1_id = brand1
          var group2_id = ''
          if(brand2 == null)
            group2_id = '전체'
          else
            group2_id = brand2
          //////////////////////////////////////////////////////////////////////////
          var node_cntR = 0
          var node_cntL = 0

          this.compareNodesSubBrand1 = []
          this.compareLinksSubBrand1 = []
          this.compareNodesSubBrand1.push({ id: group1_id, group: 1, freq: 0, sgroup: 1 })
          this.compareNodesSubBrand1.push({ id: group2_id, group: 2, freq: 0, sgroup: 2 })
          
          this.subBrandList = []
          this.productList = []
          this.cdjContentList = []
          this.selectedNode = null

          var firstnodes = []
          var totalnodes = []

          
          for(const item of response.data.data) {
            var node_color = ''
            node_cntR += 1
            if(node_cntR <= 30){
              if(item.subTitle == '라인 브랜드'){
                this.subBrandList.push(item.sub)
                node_color = '#FF9F4A'
              }else if(item.subTitle == '상품명'){
                this.productList.push(item.sub)
                node_color = '#FF7070'
              }else{
                this.cdjContentList.push(item.sub)
                var gubun_idx = this.compareGubuns.indexOf(item.subTitle)
                node_color = this.nodeColors[gubun_idx]
              }
              firstnodes.push({id: item.sub, group: 3, gubun: item.subTitle, color: node_color, sgroup: 1})
              this.compareLinksSubBrand1.push({ source: group1_id, target: item.sub })
              //right table update
              tag_rankR += 1
              this.fetchGroupsR.push({
                rank: tag_rankR,
                tag: item.sub,
                frequency: Math.round(item.freq),
                color: node_color,
                sgroup: 1
              })
            }
          }

          var firstnodeid = []
          for(const node of firstnodes){
            firstnodeid.push(node.id)
          }

          var secondnodes = []

          for(const item of response2.data.data) {
            var node_color = ''
            node_cntL += 1
            if(node_cntL <= 30){
              if(item.subTitle == '라인 브랜드'){
                this.subBrandList.push(item.sub)
                node_color = '#FF9F4A'
              }else if(item.subTitle == '상품명'){
                this.productList.push(item.sub)
                node_color = '#FF7070'
              }else{
                this.cdjContentList.push(item.sub)
                var gubun_idx = this.compareGubuns.indexOf(item.subTitle)
                node_color = this.nodeColors[gubun_idx]
              }

              secondnodes.push({id: item.sub, group: 3, gubun: item.subTitle, color: node_color, sgroup: 2})
              
              this.compareLinksSubBrand1.push({ source: group2_id, target: item.sub })
              //right table update
              tag_rankL += 1
              this.fetchGroupsL.push({
                rank: tag_rankL,
                tag: item.sub,
                frequency: Math.round(item.freq),
                color: node_color,
                sgroup: 2
              })
            }
          }

          var secondnodeid = []
          for(const node of secondnodes){
            secondnodeid.push(node.id)
          }

          const dupid = firstnodeid.filter(item => secondnodeid.includes(item))
          this.dupNodeId = dupid
          for(const item of firstnodes){
            if(dupid.includes(item.id)){
                totalnodes.push({id: item.id, group: 3, gubun: item.gubun, color: item.color, sgroup: 3})    
            }else{
              totalnodes.push({id: item.id, group: 3, gubun: item.gubun, color: item.color, sgroup: 1})    
            }
          }
          for(const item of secondnodes){
            if(!dupid.includes(item.id)){
              totalnodes.push({id: item.id, group: 3, gubun: item.gubun, color: item.color, sgroup: 2})    
            }
          }

          // totalnodes = totalnodes.concat(nodupnodes)

          // const set = new Set(totalnodes);
          // const uniqueTotalnodes = [...set];

          // for(const item of uniqueTotalnodes){
          //   this.compareNodesSubBrand1.push(item)
          // }

          for(const item of totalnodes){
            this.compareNodesSubBrand1.push(item)
          }

          // tag 확인
          for(const item of this.fetchGroupsL){
            if(dupid.includes(item.tag)){
              item.sgroup = 3
            }
          }
          for(const item of this.fetchGroupsR){
            if(dupid.includes(item.tag)){
              item.sgroup = 3
            }
          }


          console.log('-------------------------------------------------------------------------------------')
          console.log('- nodes -')
          console.log(this.compareNodesSubBrand1)
          console.log('- links -')
          console.log(this.compareLinksSubBrand1)




          if(document.getElementById('compareNet1')){
            document.getElementById('compareNet1').style.visibility = "visible";
          }
          if(document.getElementById('compareLoadingNet1')){
            document.getElementById('compareLoadingNet1').style.visibility = "hidden";
          }
          if(document.getElementById('tagCol2')){
            document.getElementById('tagCol2').style.visibility = "visible";
          }
        }


      }

      

    },
    

    abort(isReset, message) {
      // cancel the request
      source.cancel(message);

      if (isReset)
        source = cancelToken.source();
    },
    
  },
  created() {
    console.log('compare modal created')
    

  },
  computed: {


  },
  mounted() {
    console.log('compare modal mounted')

  }
};
</script>

<style>

#compare-modal > div {
  max-width: 95%;
}

#compare-modal2 > div {
  max-width: 95%;
}

#compare-modal3 > div {
  max-width: 95%;
}

.modal-lg,
.modal-xl {
  width: 100%;
  height: 100%;
}

#compare-modal___BV_modal_title_
{
    font-family: "NanumBarunGothic", Arial, sans-serif !important;
    font-weight: bold;
}

#compare-modal2___BV_modal_title_
{
    font-family: "NanumBarunGothic", Arial, sans-serif !important;
    font-weight: bold;
}

#compare-modal3___BV_modal_title_
{
    font-family: "NanumBarunGothic", Arial, sans-serif !important;
    font-weight: bold;
}


.select-brand .vs__dropdown-menu
{
  padding: 0px 0px 0px 0px;
}


.compareSideMenu {
  background-color: #fff;
  border: 1px solid #d8d6de;
  padding: 10px;
  margin-top: 0.5rem;
  height: 100%;
  max-height: 700px;
}

.compareSideMenuInner {
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 600px;
  max-height: 600px;
}


/* Hide default icon */
.tableR .table.b-table > thead > tr > th,
.tableR .table.b-table > tfoot > tr > td {
  background-image: none !important;
  vertical-align: middle !important;
  padding: 0.75rem 0.5rem;
}

.tableR .table-font-size
 {
  font-size: 12px;
  font-weight: 600;
}

.tableR .b-table thead th.w20{
  width: 20%;
}

#searchTagTableR > tbody > .table-active > td
{
    background-color: #D4EEFE;
}

.tableL .table.b-table > thead > tr > th,
.tableL .table.b-table > tfoot > tr > td {
  background-image: none !important;
  vertical-align: middle !important;
  padding: 0.75rem 0.5rem;
}

.tableL .table-font-size
 {
  font-size: 12px;
  font-weight: 600;
}

.tableL .b-table thead th.w20{
  width: 20%;
}

#searchTagTableL > tbody > .table-active > td
{
    background-color: #D4EEFE;
}








/* ////////////////////////////////////////////////////
/// 
/// checkbox styling
/// 
///////////////////////////////////////////////////// */
#CsubBrand:disabled:checked ~ .custom-control-label::before,
#CsubBrand:checked ~ .custom-control-label::before,
#CsubBrand:active ~ .custom-control-label::before
{
  background-color: #FFB777;
  border-color: #FFB777;
}
#CsubBrand ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #FFB777;
  border-width: 4px;
  border-radius: 4px;
}


#CproductName:disabled:checked ~ .custom-control-label::before,
#CproductName:checked ~ .custom-control-label::before,
#CproductName:active ~ .custom-control-label::before
{
  background-color: #FF7070;
  border-color: #FF7070;
}
#CproductName ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #FF7070;
  border-width: 4px;
  border-radius: 4px;
}

/* /////////////////////////////////////////////////////////////////////////////// */

#Cattr00:disabled:checked ~ .custom-control-label::before,
#Cattr00:checked ~ .custom-control-label::before,
#Cattr00:active ~ .custom-control-label::before
{
  background-color: #FDA8AA;
  border-color: #FDA8AA;
}
#Cattr00 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #FDA8AA;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr01:disabled:checked ~ .custom-control-label::before,
#Cattr01:checked ~ .custom-control-label::before,
#Cattr01:active ~ .custom-control-label::before
{
  background-color: #86C98A;
  border-color: #86C98A;
}
#Cattr01 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #86C98A;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr02:disabled:checked ~ .custom-control-label::before,
#Cattr02:checked ~ .custom-control-label::before,
#Cattr02:active ~ .custom-control-label::before
{
  background-color: #887CAF;
  border-color: #887CAF;
}
#Cattr02 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #887CAF;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr03:disabled:checked ~ .custom-control-label::before,
#Cattr03:checked ~ .custom-control-label::before,
#Cattr03:active ~ .custom-control-label::before
{
  background-color: #E3A209 ;
  border-color: #E3A209 ;
}
#Cattr03 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #E3A209 ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr04:disabled:checked ~ .custom-control-label::before,
#Cattr04:checked ~ .custom-control-label::before,
#Cattr04:active ~ .custom-control-label::before
{
  background-color: #CB87AF  ;
  border-color: #CB87AF  ;
}
#Cattr04 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #CB87AF  ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr05:disabled:checked ~ .custom-control-label::before,
#Cattr05:checked ~ .custom-control-label::before,
#Cattr05:active ~ .custom-control-label::before
{
  background-color: #09D8E3  ;
  border-color: #09D8E3  ;
}
#Cattr05 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #09D8E3  ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr06:disabled:checked ~ .custom-control-label::before,
#Cattr06:checked ~ .custom-control-label::before,
#Cattr06:active ~ .custom-control-label::before
{
  background-color: #FFD1AA  ;
  border-color: #FFD1AA  ;
}
#Cattr06 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #FFD1AA  ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr07:disabled:checked ~ .custom-control-label::before,
#Cattr07:checked ~ .custom-control-label::before,
#Cattr07:active ~ .custom-control-label::before
{
  background-color: #748BA7   ;
  border-color: #748BA7   ;
}
#Cattr07 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #748BA7   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr08:disabled:checked ~ .custom-control-label::before,
#Cattr08:checked ~ .custom-control-label::before,
#Cattr08:active ~ .custom-control-label::before
{
  background-color: #9675AB   ;
  border-color: #9675AB   ;
}
#Cattr08 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #9675AB   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr09:disabled:checked ~ .custom-control-label::before,
#Cattr09:checked ~ .custom-control-label::before,
#Cattr09:active ~ .custom-control-label::before
{
  background-color: #0993E3   ;
  border-color: #0993E3   ;
}
#Cattr09 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #0993E3   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr10:disabled:checked ~ .custom-control-label::before,
#Cattr10:checked ~ .custom-control-label::before,
#Cattr10:active ~ .custom-control-label::before
{
  background-color: #D46A6A   ;
  border-color: #D46A6A   ;
}
#Cattr10 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #D46A6A   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr11:disabled:checked ~ .custom-control-label::before,
#Cattr11:checked ~ .custom-control-label::before,
#Cattr11:active ~ .custom-control-label::before
{
  background-color: #55AA55   ;
  border-color: #55AA55   ;
}
#Cattr11 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #55AA55   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr12:disabled:checked ~ .custom-control-label::before,
#Cattr12:checked ~ .custom-control-label::before,
#Cattr12:active ~ .custom-control-label::before
{
  background-color: #615192   ;
  border-color: #615192   ;
}
#Cattr12 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #615192   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr13:disabled:checked ~ .custom-control-label::before,
#Cattr13:checked ~ .custom-control-label::before,
#Cattr13:active ~ .custom-control-label::before
{
  background-color: #D4C16A   ;
  border-color: #D4C16A   ;
}
#Cattr13 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #D4C16A   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr14:disabled:checked ~ .custom-control-label::before,
#Cattr14:checked ~ .custom-control-label::before,
#Cattr14:active ~ .custom-control-label::before
{
  background-color: #18516f   ;
  border-color: #18516f   ;
}
#Cattr14 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #18516f   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr15:disabled:checked ~ .custom-control-label::before,
#Cattr15:checked ~ .custom-control-label::before,
#Cattr15:active ~ .custom-control-label::before
{
  background-color: #4F608F   ;
  border-color: #4F608F   ;
}
#Cattr15 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #4F608F   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr16:disabled:checked ~ .custom-control-label::before,
#Cattr16:checked ~ .custom-control-label::before,
#Cattr16:active ~ .custom-control-label::before
{
  background-color: #D4A16A   ;
  border-color: #D4A16A   ;
}
#Cattr16 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #D4A16A   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr17:disabled:checked ~ .custom-control-label::before,
#Cattr17:checked ~ .custom-control-label::before,
#Cattr17:active ~ .custom-control-label::before
{
  background-color: #AA3939   ;
  border-color: #AA3939   ;
}
#Cattr17 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #AA3939   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr18:disabled:checked ~ .custom-control-label::before,
#Cattr18:checked ~ .custom-control-label::before,
#Cattr18:active ~ .custom-control-label::before
{
  background-color: #2D882D   ;
  border-color: #2D882D   ;
}
#Cattr18 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #2D882D   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr19:disabled:checked ~ .custom-control-label::before,
#Cattr19:checked ~ .custom-control-label::before,
#Cattr19:active ~ .custom-control-label::before
{
  background-color: #403075   ;
  border-color: #403075   ;
}
#Cattr19 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #403075   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr20:disabled:checked ~ .custom-control-label::before,
#Cattr20:checked ~ .custom-control-label::before,
#Cattr20:active ~ .custom-control-label::before
{
  background-color: #AA9439   ;
  border-color: #AA9439   ;
}
#Cattr20 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #AA9439   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr21:disabled:checked ~ .custom-control-label::before,
#Cattr21:checked ~ .custom-control-label::before,
#Cattr21:active ~ .custom-control-label::before
{
  background-color: #2E4172   ;
  border-color: #2E4172   ;
}
#Cattr21 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #2E4172   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr22:disabled:checked ~ .custom-control-label::before,
#Cattr22:checked ~ .custom-control-label::before,
#Cattr22:active ~ .custom-control-label::before
{
  background-color: #AA7239   ;
  border-color: #AA7239   ;
}
#Cattr22 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #AA7239   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr23:disabled:checked ~ .custom-control-label::before,
#Cattr23:checked ~ .custom-control-label::before,
#Cattr23:active ~ .custom-control-label::before
{
  background-color: #801515   ;
  border-color: #801515   ;
}
#Cattr23 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #801515   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr24:disabled:checked ~ .custom-control-label::before,
#Cattr24:checked ~ .custom-control-label::before,
#Cattr24:active ~ .custom-control-label::before
{
  background-color: #196811   ;
  border-color: #196811   ;
}
#Cattr24 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #196811   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr25:disabled:checked ~ .custom-control-label::before,
#Cattr25:checked ~ .custom-control-label::before,
#Cattr25:active ~ .custom-control-label::before
{
  background-color: #261758   ;
  border-color: #261758   ;
}
#Cattr25 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #261758   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr26:disabled:checked ~ .custom-control-label::before,
#Cattr26:checked ~ .custom-control-label::before,
#Cattr26:active ~ .custom-control-label::before
{
  background-color: #806C15   ;
  border-color: #806C15   ;
}
#Cattr26 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #806C15   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr27:disabled:checked ~ .custom-control-label::before,
#Cattr27:checked ~ .custom-control-label::before,
#Cattr27:active ~ .custom-control-label::before
{
  background-color: #162955   ;
  border-color: #162955   ;
}
#Cattr27 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #162955   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr28:disabled:checked ~ .custom-control-label::before,
#Cattr28:checked ~ .custom-control-label::before,
#Cattr28:active ~ .custom-control-label::before
{
  background-color: #804815   ;
  border-color: #804815   ;
}
#Cattr28 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #804815   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr29:disabled:checked ~ .custom-control-label::before,
#Cattr29:checked ~ .custom-control-label::before,
#Cattr29:active ~ .custom-control-label::before
{
  background-color: #550200   ;
  border-color: #550200   ;
}
#Cattr29 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #550200   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr30:disabled:checked ~ .custom-control-label::before,
#Cattr30:checked ~ .custom-control-label::before,
#Cattr30:active ~ .custom-control-label::before
{
  background-color: #034500   ;
  border-color: #034500   ;
}
#Cattr30 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #034500   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr31:disabled:checked ~ .custom-control-label::before,
#Cattr31:checked ~ .custom-control-label::before,
#Cattr31:active ~ .custom-control-label::before
{
  background-color: #13073A   ;
  border-color: #13073A   ;
}
#Cattr31 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #13073A   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr32:disabled:checked ~ .custom-control-label::before,
#Cattr32:checked ~ .custom-control-label::before,
#Cattr32:active ~ .custom-control-label::before
{
  background-color: #554600   ;
  border-color: #554600   ;
}
#Cattr32 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #554600   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr33:disabled:checked ~ .custom-control-label::before,
#Cattr33:checked ~ .custom-control-label::before,
#Cattr33:active ~ .custom-control-label::before
{
  background-color: #061539   ;
  border-color: #061539   ;
}
#Cattr33 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #061539   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr34:disabled:checked ~ .custom-control-label::before,
#Cattr34:checked ~ .custom-control-label::before,
#Cattr34:active ~ .custom-control-label::before
{
  background-color: #552700   ;
  border-color: #552700   ;
}
#Cattr34 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #552700   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr35:disabled:checked ~ .custom-control-label::before,
#Cattr35:checked ~ .custom-control-label::before,
#Cattr35:active ~ .custom-control-label::before
{
  background-color: #AA5585   ;
  border-color: #AA5585   ;
}
#Cattr35 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #AA5585   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr36:disabled:checked ~ .custom-control-label::before,
#Cattr36:checked ~ .custom-control-label::before,
#Cattr36:active ~ .custom-control-label::before
{
  background-color: #B4CB65   ;
  border-color: #B4CB65   ;
}
#Cattr36 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #B4CB65   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr37:disabled:checked ~ .custom-control-label::before,
#Cattr37:checked ~ .custom-control-label::before,
#Cattr37:active ~ .custom-control-label::before
{
  background-color: #18516f   ;
  border-color: #18516f   ;
}
#Cattr37 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #18516f   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr38:disabled:checked ~ .custom-control-label::before,
#Cattr38:checked ~ .custom-control-label::before,
#Cattr38:active ~ .custom-control-label::before
{
  background-color: #724C8F   ;
  border-color: #724C8F   ;
}
#Cattr38 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #724C8F   ;
  border-width: 4px;
  border-radius: 4px;
}

#Cattr39:disabled:checked ~ .custom-control-label::before,
#Cattr39:checked ~ .custom-control-label::before,
#Cattr39:active ~ .custom-control-label::before
{
  background-color: #467386   ;
  border-color: #467386   ;
}
#Cattr39 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #467386   ;
  border-width: 4px;
  border-radius: 4px;
}




</style>